import { graphql } from 'react-relay';

export const trancheSelectionFragment = graphql`
  fragment TrancheSelection_component on TrancheSelection {
    tranches {
      ...LabeledSelectBox_labeledSelectBox
      trancheSelectBox : selectbox {
        options {
          key
          label
        }
      }
    }
  }
`;
